
import React from 'react';

const Footer: React.FC = () => {
  const openZalo = () => {
    window.open('https://zalo.me/0989993004', '_blank');
  };

  const openFacebook = () => {
    window.open('https://facebook.com/giatui.minhkhoi.dalat', '_blank');
  };

  const callHotline = () => {
    window.open('tel:0989993004', '_self');
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-shirt-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold">Giặt Ủi Minh Khôi</h3>
                  <p className="text-gray-400 text-sm">Đà Lạt</p>
                </div>
              </div>
              
              <p className="text-gray-300 mb-6 leading-relaxed">
                Dịch vụ giặt ủi chuyên nghiệp tại Đà Lạt với tiêu chuẩn khách sạn 5 sao. 
                Giặt sạch, trả nhanh, chất lượng đảm bảo.
              </p>

              <div className="space-y-3">
                <div className="flex items-center">
                  <i className="ri-map-pin-line text-blue-400 mr-3"></i>
                  <span className="text-gray-300">Cửa hàng & Xưởng Giặt Ủi Minh Khôi, Đà Lạt</span>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-phone-line text-teal-400 mr-3"></i>
                  <button 
                    onClick={callHotline}
                    className="text-teal-400 hover:text-teal-300 cursor-pointer"
                  >
                    0961 686 191
                  </button>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-time-line text-green-400 mr-3"></i>
                  <span className="text-gray-300">Hỗ trợ 24/7</span>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-6">Liên kết nhanh</h4>
              <ul className="space-y-3">
                <li>
                  <button 
                    onClick={() => scrollToSection('home')}
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    Trang chủ
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('about')}
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    Giới thiệu
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('services')}
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    Dịch vụ
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('pricing')}
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    Bảng giá
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('contact')}
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    Liên hệ
                  </button>
                </li>
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-lg font-semibold mb-6">Dịch vụ</h4>
              <ul className="space-y-3">
                <li className="text-gray-300">Giặt ủi khách sạn</li>
                <li className="text-gray-300">Giặt ủi gia đình</li>
                <li className="text-gray-300">Giặt khô chuyên nghiệp</li>
                <li className="text-gray-300">Express 24h</li>
                <li className="text-gray-300">Giao nhận tận nơi</li>
              </ul>
            </div>
          </div>

          {/* Social Media & CTA */}
          <div className="border-t border-gray-800 mt-12 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="flex space-x-6 mb-6 md:mb-0">
                <button 
                  onClick={openFacebook}
                  className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-fill text-white"></i>
                </button>
                
                <button 
                  onClick={openZalo}
                  className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer"
                >
                  <i className="ri-message-3-fill text-white"></i>
                </button>
                
                <button 
                  onClick={callHotline}
                  className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center hover:bg-teal-700 transition-colors cursor-pointer"
                >
                  <i className="ri-phone-fill text-white"></i>
                </button>
              </div>

              <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-6">
                <button
                  onClick={() => scrollToSection('booking')}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-calendar-check-line mr-2"></i>
                  Đặt giặt ngay
                </button>
                
                <button
                  onClick={openZalo}
                  className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-message-3-line mr-2"></i>
                  Chat Zalo
                </button>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t border-gray-800 mt-8 pt-8 text-center">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 text-sm mb-4 md:mb-0">
                © 2024 Giặt Ủi Minh Khôi. Tất cả quyền được bảo lưu.
              </p>
              <div className="flex items-center space-x-4">
                <span className="text-gray-400 text-sm">Được hỗ trợ bởi</span>
                <a 
                  href="https://readdy.ai/?origin=logo" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-400 hover:text-blue-300 text-sm font-medium cursor-pointer"
                >
                  Website Builder
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
